/** Value types accepted as URL query parameter values. Arrays are appended as repeated keys. */
export type UrlParamValue = string | number | boolean | string[] | undefined;

/**
 * Appends query parameters to a URL string, skipping nullish values.
 * Arrays are serialized as repeated keys: `key=a&key=b`.
 */
export function buildUrlWithParams(baseUrl: string, params?: Record<string, UrlParamValue>): string {
  if (!params) {
    return baseUrl;
  }

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value == null) {
      continue;
    }
    if (Array.isArray(value)) {
      value.forEach(v => searchParams.append(key, String(v)));
    } else {
      searchParams.append(key, String(value));
    }
  }

  const queryString = searchParams.toString();
  if (!queryString) {
    return baseUrl;
  }

  return baseUrl.includes('?') ? `${baseUrl}&${queryString}` : `${baseUrl}?${queryString}`;
}
